import { render, staticRenderFns } from "./transmit.vue?vue&type=template&id=02c913a7&scoped=true&"
import script from "./transmit.vue?vue&type=script&lang=js&"
export * from "./transmit.vue?vue&type=script&lang=js&"
import style0 from "./transmit.vue?vue&type=style&index=0&id=02c913a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c913a7",
  null
  
)

export default component.exports